import { currencyData } from "../utils/constants";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import ProductCard from "./common/ProductCard";

const SaleProductSliderGrid = ({ products }) => {
    let currency = getFromLocalStorage(currencyData);

    return (
        <>
            {products?.map((product, index) => (
                <div className="col-xl-4 col-lg-4 col-md-6 col-6" key={'sale-product-slider-grid' + index}>
                    <ProductCard product={product} currency={currency} />
                </div>
            ))}
        </>
    );
};

export default SaleProductSliderGrid;
